import React from "react";
import "./Container.scss";

/**
 * Container component for consistent max-width and padding
 */
const Container = ({
  children,
  className = "",
  as: Component = "div",
  ...props
}) => {
  return (
    <Component className={`container ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
};

export default Container;
